module.exports = __webpack_public_path__ + "odinstatic/v6.4.0/media/pod.cbb0a7b1.svg";